import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  ref: "scrollbar",
  class: "el-scrollbar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bar = _resolveComponent("bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "wrap",
      class: _normalizeClass([
        _ctx.wrapClass,
        'el-scrollbar__wrap',
        _ctx.native ? '' : 'el-scrollbar__wrap--hidden-default',
      ]),
      style: _normalizeStyle(_ctx.style),
      onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
    }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), {
        ref: "resize",
        class: _normalizeClass(['el-scrollbar__view', _ctx.viewClass]),
        style: _normalizeStyle(_ctx.viewStyle)
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class", "style"]))
    ], 38),
    (!_ctx.native)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_bar, {
            move: _ctx.moveX,
            size: _ctx.sizeWidth
          }, null, 8, ["move", "size"]),
          _createVNode(_component_bar, {
            vertical: "",
            move: _ctx.moveY,
            size: _ctx.sizeHeight
          }, null, 8, ["move", "size"])
        ], 64))
      : _createCommentVNode("", true)
  ], 512))
}